import * as React from "react";
import styles from "./MainMetricsAnalysisContent.module.scss";
import SelectBox from "../../../../../Componnets/SelectBox/SelectBox";

const MainMetricsAnalysisContent = ({ data }) => {
  const [dataset, setDataset] = React.useState([])
  const [metric, setMetric] = React.useState("max")
  const [dropDownOptions, setDropDownOptions] = React.useState([])
  const [dropDownValue, setDropDownValue] = React.useState(null)

  const mapNames = {
    avg_cost: "Average Cost",
    total_cost: "Total Cost",
    avg_duration: "Average Duration",
    total_duration: "Total Duration",
  }

  const timeCalculator = (seconds) => {
    let y = Math.floor(seconds / 31536000);
    let mo = Math.floor((seconds % 31536000) / 2628000);
    let d = Math.floor(((seconds % 31536000) % 2628000) / 86400);
    let h = Math.floor((seconds % (3600 * 24)) / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    let s = Math.floor(seconds % 60);

    let yDisplay = y > 0 ? y + "y" : "";
    let moDisplay = mo > 0 ? " " + mo + "m" : "";
    let dDisplay = d > 0 ? " " +  d + "d" : "";
    let hDisplay = h > 0 ? " " +  h + "h" : "";
    let mDisplay = m > 0 ? " " +  m + "m" : "";
    let sDisplay = s > 0 ? " " +  s + "s" : "";
    return yDisplay + moDisplay + dDisplay + hDisplay + mDisplay + sDisplay;
  }

  React.useEffect(() => {
    if (data) {
      const options = Object.keys(data)?.map(item => ({title: item, value: item}))
      setDropDownOptions(options)
      if (!dropDownValue) {
        setDropDownValue(options?.[0])
      }
    }
  }, [data])

  React.useEffect(() => {
    if (dropDownValue && data[dropDownValue.value]) {
      const d = Object.entries(data[dropDownValue.value])?.map(([key, value]) => ({
        title: key,
        name: value?.[metric]?.name,
        value: key === "avg_duration" || key === "total_duration" ? timeCalculator(value?.[metric]?.value) ? timeCalculator(value?.[metric]?.value) : 0 : value?.[metric]?.value?.toLocaleString(),
        cases: value?.[metric]?.cases?.toLocaleString()
      }))
      setDataset(d)
    }
  }, [dropDownValue, metric, data])

  return (
    <div className={'row'}>
      <div className={'col-md-12 px-1'}>
        <div className={styles.mainMetricsAnalysisContent}>
          <div className={[styles.header, 'd-flex justify-content-between'].join(' ')}>
            <div>
              <div className={styles.title}>
                Metrics Analysis
                <div className={'d-flex ml-3'}>
                  <div className={[styles.button, metric === "max" && styles.active].join(' ')} onClick={() => setMetric("max")}>Biggest</div>
                  <div className={[styles.button, metric === "min" && styles.active, 'ml-1'].join(' ')} onClick={() => setMetric("min")}>Smallest</div>
                </div>
              </div>
            </div>
            <div className={styles.dropDown}>
              <SelectBox
                style={{border: 0}}
                dontShowSearch
                block
                singleSelect
                options={dropDownOptions.length && dropDownOptions}
                dropDownValue={dropDownValue}
                onSelectOption={(value) => setDropDownValue(value)}
              />
            </div>
          </div>
          <div className={['container', styles.body].join(' ')}>
            <table>
              {
                dataset.map(item => ((item.name || item.value) &&
                  <tr>
                    <td className={styles.title}>{ mapNames[item.title] }</td>
                    <td className={styles.desc}>{ item.name }</td>
                    <td className={styles.time}>{ item.value }</td>
                    <td className={styles.cases}>{ item.cases } {item.cases && "Cases"}</td>
                    <td className={[styles.show, 'disable'].join(' ')}>{item.name && "Show"}</td>
                  </tr>
                ))
              }
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainMetricsAnalysisContent